import React from "react";
import Money from "components/money";
import OkendoStarRating from "components/okendo/star-rating";
import useToggle from "hooks/useToggle";
import ShareListModal from "./modal/share";
import Link from "components/link";
import { toast } from "react-toastify";
import { useWishlist, useCart } from "hooks/useStore";
import { ReactComponent as DirectionalArrow } from "svgs/navigation-arrow.svg";
import { ReactComponent as Share } from "svgs/fi-rs-share.svg";
import WishlistEmpty from "./empty";
import usePostATCAction from "hooks/usePostATCAction";

const ListCard = ({ list, navigateBack, sharedList }) => {
	const { removeVariantFromList } = useWishlist(["removeVariantFromList"]);
	const { addCartItem } = useCart(["addCartItem"]);
	const [shareListModalOpen, toggleShareListModal] = useToggle();
	const postAddToCartAction = usePostATCAction();

	const handleAddToCart = async (id) => {
		const variantId = `gid://shopify/ProductVariant/${id}`;
		await addCartItem(variantId);
		postAddToCartAction();
	};

	const handleRemoveItem = async (productId, variantId, url) => {
		const res = removeVariantFromList(list.lid, productId, variantId, url);
		if (res.error) {
			toast.error("Error removing item from list");
		}
		else {
			toast.success("Item removed from list");
		}
	};

	return (
		<>
			{shareListModalOpen && <ShareListModal list={list} isOpen={shareListModalOpen} toggle={toggleShareListModal} />}
			<div className="py-5 flex flex-col standard-section-width mx-auto">
				<div className="flex justify-between items-center px-2">
					<button onClick={navigateBack}>
						<DirectionalArrow className="fill-black rotate-180" />
					</button>
					<div className="flex flex-col pb-5 border-b w-full items-center">
						<h2>{list.lname}</h2>
						<p className="text-secondary">{list.lnote}</p>
						{sharedList && (
							<p className="p-5 text-left">
								{`You are viewing a read-only list shared by 
								${list.userinfo?.fname} ${list.userinfo?.lname} (${list.userinfo?.em})
								.`}
								<Link to="/account/login" className="underline">
									To edit the list, log in with the email it was shared with.
								</Link>
							</p>
						)}
					</div>
					{!sharedList &&
						<button onClick={toggleShareListModal}>
							<Share />
						</button>
					}
				</div>
				<div className="flex flex-wrap gap-5 sm:gap-6 pt-5 sm:justify-center">
					{list?.listcontents?.length > 0 ? (
						list?.listcontents?.map((item, index) => (
							<div key={index} className="w-[calc(50%-10px)] sm:w-72">
								<div className="relative">
									<img src={item.iu} alt={item.dt} loading="lazy" />
									{!sharedList && (
										<div className="absolute top-4 right-4">
											<button onClick={() => handleRemoveItem(item.empi, item.epi, item.du)}
												className="px-2 py-1 bg-black opacity-80 text-white">
												X
											</button>
										</div>
									)}
									<div className="absolute bottom-0 w-full">
										<button
											className="w-full btn-secondary text-xs md:text-sm py-2 px-4 sm:py-4 sm:px-12"
											onClick={() => handleAddToCart(item.epi)}
										>
											Add to cart
										</button>
									</div>
								</div>
								<div className="flex justify-between">
									<div className="flex flex-col items-start">
										<h5 className="font-bold">{item.dt}</h5>
										<div className="small-size-rating">
											<OkendoStarRating productId={item?.empi} />
										</div>
									</div>
									<div className="flex flex-col justify-start items-end">
										<span className="text-secondary text-xs md:text-sm">From</span>
										<p className="md:text-2xl font-semibold ml-2">
											<Money value={item?.pr} />
										</p>
									</div>
								</div>
							</div>
						))
					) : (
						<WishlistEmpty />
					)}
				</div>
			</div>
		</>
	);
};

export default ListCard;